import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import { useGetEmailHubStatus } from "@circle-react/hooks/useGetEmailHubStatus";

const EmailHubStatusContext = createContext<ReturnType<
  typeof useGetEmailHubStatus
> | null>(null);

EmailHubStatusContext.displayName = "EmailHubStatusContext";

export const useEmailHubStatus = () => {
  const context = useContext(EmailHubStatusContext);
  invariant(
    context,
    "useEmailHubStatus must be used within an EmailHubStatusProvider",
  );
  return context;
};

interface EmailHubStatusProviderProps {
  children: ReactNode;
}

export const EmailHubStatusProvider = ({
  children,
}: EmailHubStatusProviderProps) => {
  const emailHubStatus = useGetEmailHubStatus();

  return (
    <EmailHubStatusContext.Provider value={emailHubStatus}>
      {children}
    </EmailHubStatusContext.Provider>
  );
};
